<template>
  <div class="c2025-peertube pt-3">
    <b-row class="p-2">
      <b-col lg="3">
        <img
          src="../../../../public/img/campaign/2025/pt/sepia_love.svg"
          alt="PeerTube Logo"
          class="peertube-logo rounded-circle img-fluid my-3 mx-auto d-block"
        />
      </b-col>
      <b-col lg="9">
        <div class="p-2 d-flex flex-column">
          <h3>{{ $t('c2025.peertube.server.title') }}</h3>
          <div v-html="$t('c2025.peertube.server.description')"></div>
          <a
            v-if="isPublished($t('c2025.peertube.server.publicationDate'))"
            :href="$t('c2025.peertube.server.presentationLinkUrl')"
            class="btn btn-outline-warning align-self-center"
            target="_blank"
            rel="noopener"
          >
            {{ $t('c2025.topics.buttons.read') }}
          </a>
          <b-button
            v-else
            variant="outline-warning"
            class="align-self-center"
            disabled
          >
            {{ $t('c2025.topics.buttons.read_soon') }}
          </b-button>
        </div>
      </b-col>
    </b-row>
    <hr />
    <b-row class="mt-3 p-2">
      <b-col lg="3">
        <img
          alt=""
          class="peertube-logo img-fluid my-3 mx-auto d-block"
          src="../../../../public/img/campaign/2025/pt/mobile-app.png"
          loading="lazy"
        />
      </b-col>
      <b-col lg="9">
        <div class="p-2 d-flex flex-column">
          <h3>{{ $t('c2025.peertube.app.title') }}</h3>
          <div
            v-html="$t('c2025.peertube.app.description')"
          ></div>
          <a
            v-if="isPublished($t('c2025.peertube.app.publicationDate'))"
            :href="$t('c2025.peertube.app.presentationLinkUrl')"
            class="btn btn-outline-warning align-self-center"
            target="_blank"
            rel="noopener"
          >
            {{ $t('c2025.topics.buttons.read') }}
          </a>
          <b-button
            v-else
            variant="outline-warning"
            class="align-self-center"
            disabled
          >
            {{ $t('c2025.topics.buttons.read_soon') }}
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script setup>
const isPublished = (publicationDate) => {
  const pubDate = new Date(new Date(publicationDate).getTime() + 12 * 60 * 60 * 1000);
  const now = new Date();
  return pubDate <= now;
};

</script>

<style lang="scss">
.c2025-peertube {
  background: var(--f-g1);
  position: relative;
  z-index: 10;
  top: -4rem;
  background-color: #fff;
  border: 2px solid #FFC99E;
  border-radius: 7px;

  .peertube-logo {
    max-height: 10rem;
  }

  h3 {
    color: var(--g-9);
    font-size: 1.75rem;
  }

  hr {
    border-color: #FFC99E;
  }

  .btn-outline-warning:disabled {
    &:disabled {
      opacity: 1;
    }
  }
}
</style>
